export const IconThread = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='48' height='55' viewBox='0 0 48 55'>
    <path
      d='
                  M24 1
                  L24 11
                  C24 26, 12 36, 6 26
                  C2 12, 24 6, 24 41
                  L24 46
                '
      fill='none'
      stroke='currentColor'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
